<div class="flex flex-col w-full h-full">
  <app-header></app-header>
  <main
    class="m-auto w-screen xs:max-w-screen-xs sm:max-w-screen-sm md:max-w-screen-md lg:max-w-screen-lg xl:max-w-screen-xl xxl:max-w-screen-xxl"
  >
    <router-outlet></router-outlet>
  </main>
  <app-footer></app-footer>
</div>


<app-cookie-consent></app-cookie-consent>

